{
  "Belastet": "Last",
  "BelastetBerechtigt": "Last und Recht",
  "Berechtigt": "Recht",
  "dashboard.rechtehinweis.legalHintComment": " ",
  "dashboard.rechtehinweis.legalHintComment1": " ",
  "dashboard.rechtehinweis.legalHintHeader": "Hinweis: Rechtsgültigkeit der Daten",
  "dashboard.rechtehinweis.legalHintMessage": "Keine Gewähr bezüglich Richtigkeit und Aktualität der Daten. Massgebend sind die Grundbuchdaten.",
  "L": "Last",
  "LastRechtAbkürzung": "Last und Recht",
  "layouts.page.title": "Intercapi public",
  "LR": "Last und Recht",
  "R": "Recht",
  "rechteId": "Rechte-Id",
  "ZuGunsten": "zu Gunsten",
  "ZuGunstenLasten": "zu Lasten und zu Gunsten",
  "ZuLasten": "zu Lasten"
}
